export const DATE_FORMATS = {
  YYYY_MM_DDTHH_mm_ss: 'YYYY-MM-DDTHH:mm:ss',
  YYYY_MM_DD: 'YYYY-MM-DD',
  yyyy_MM_dd: 'yyyy-MM-dd',
  DD_MM_YY: 'dd/MM/yy',
  DD_MM_YYYY: 'dd/MM/yyyy',
  DISPLAY_DATE_TIME: 'M/D/YYYY, h:mm:ss A',
  DD_MM_YYYY_HH_mm: 'DD/MM/YYYY HH:mm',
  DD_MM_YYYY_HH_mm_A: 'DD/MM/YYYY hh:mm A',
  DD_MM_YYYY_NUMERIC: 'DD/MM/YYYY',
  HH_mm_A: 'HH:mm A',
  MM_DD_YYYY_HH_mm_A: 'MM/DD/YYYY hh:mm A',
  MM_DD_YYYY_HH_mm_A_COMMA: 'MM/DD/YYYY, hh:mm A',
  MM_DD_YYYY_NUMERIC: 'MM/DD/YYYY',
  hh_mm_A: 'hh:mm A',
};

export default DATE_FORMATS;
